// Every event type the trial event log can record, used to populate the type
// filter on the trial's Logs tab. Team member events are those written by
// `log_trial_event` in the API; participant events those written by
// `log_participant_event`.
//
// This list is maintained by hand and is not enforced at runtime — a type
// missing from it simply can't be filtered for, so keep it in step when you
// add a new event to the API. `api/tests/test_log_event_types.py` fails if it
// falls behind.

export const TEAM_MEMBER_EVENT_TYPES = [
  'addGroupMember',
  'addSiteMember',
  'allocateResponseToUnallocatedParticipant',
  'approveFile',
  'assignPack',
  'broadcastSiteMessage',
  'bulkUpdateParticipants',
  'connectedToService',
  'copyFile',
  'createAnchor',
  'createAutomaticMessage',
  'createAutomaticQuery',
  'createConsentDocument',
  'createDashboard',
  'createDataType',
  'createDataTypeTag',
  'createFile',
  'createFileApproval',
  'createFileVersion',
  'createFoodDiaryEntry',
  'createGroup',
  'createMessage',
  'createMessages',
  'createNote',
  'createNotifications',
  'createPack',
  'createPacks',
  'createPackType',
  'createParticipant',
  'createParticipantEvent',
  'createParticipantLoginGrant',
  'createParticipantResource',
  'createParticipantStageLinkToken',
  'createQuery',
  'createQueryComment',
  'createResponseValidation',
  'createResponseValidations',
  'createRole',
  'createSavedFilter',
  'createSite',
  'createSiteMessage',
  'createSiteMonitoring',
  'createSiteMonitoringIssue',
  'createStage',
  'createStageGroup',
  'createStripeCheckoutSession',
  'createTask',
  'createTaskLane',
  'createUploadRequest',
  'createVideoMeeting',
  'deallocateResponseFromParticipant',
  'deleteAnchor',
  'deleteAutomaticMessage',
  'deleteAutomaticQuery',
  'deleteConsentDocument',
  'deleteDashboard',
  'deleteDataType',
  'deleteDataTypes',
  'deleteDataTypeTag',
  'deleteFile',
  'deleteFileApproval',
  'deleteFoodDiaryEntry',
  'deleteGroup',
  'deleteNote',
  'deletePack',
  'deletePacks',
  'deletePackType',
  'deleteParticipant',
  'deleteParticipantEvent',
  'deleteParticipantResource',
  'deleteParticipants',
  'deleteParticipantStageOverride',
  'deleteQuery',
  'deleteQueryComment',
  'deleteResponse',
  'deleteResponseValidation',
  'deleteResponseValidations',
  'deleteRole',
  'deleteSavedFilter',
  'deleteSite',
  'deleteSiteMonitoring',
  'deleteSiteMonitoringIssue',
  'deleteStage',
  'deleteStageGroup',
  'deleteStages',
  'deleteTask',
  'deleteTaskLane',
  'deleteTrial',
  'deleteVideoMeeting',
  'disconnectedFromService',
  'exportLogs',
  'exportResponse',
  'exportStudyRecord',
  'listConsentRecords',
  'lockedDatabase',
  'lockedDatasetRecorded',
  'lockedTrial',
  'mcp.tool_call',
  'permissionDenied',
  'readMessages',
  'readParticipantPersonalInformation',
  'removeGroupMember',
  'removeSiteMember',
  'setResponseStatus',
  'signCasebook',
  'signResponse',
  'signatureSuperseded',
  'tilloIncentiveIssued',
  'unassignPack',
  'unlockedDatabase',
  'unlockedTrial',
  'updateAnchor',
  'updateAutomaticMessage',
  'updateAutomaticQuery',
  'updateConsentDocument',
  'updateDashboard',
  'updateDataType',
  'updateDataTypes',
  'updateDataTypeTag',
  'updateFile',
  'updateFoodDiaryEntry',
  'updateGroup',
  'updateNote',
  'updatePack',
  'updatePacks',
  'updatePackType',
  'updateParticipant',
  'updateParticipantEvent',
  'updateParticipantResource',
  'updateQuery',
  'updateQueryComment',
  'updateResponse',
  'updateRole',
  'updateSavedFilter',
  'updateSite',
  'updateSiteMonitoring',
  'updateSiteMonitoringIssue',
  'updateStage',
  'updateStageGroup',
  'updateTask',
  'updateTaskLane',
  'updateTrial',
  'upsertParticipantStageOverride'
]

export const PARTICIPANT_EVENT_TYPES = [
  'clearAnchor',
  'connectGarmin',
  'connectToService',
  'createMessage',
  'createResponse',
  'disconnectFromService',
  'disconnectGarmin',
  'eConsentSubmitted',
  'exchangeLoginGrant',
  'garminDeregistration',
  'login',
  'logout',
  'markMessagesAsRead',
  'setAnchor',
  'setPushToken'
]
